import {isFulfilled} from '@reduxjs/toolkit';
import {fetchAppConfig} from '../store/slices/app_config_slice';
import {store as AppStore} from '../store/store';

export async function sleep(ms: number) {
    return new Promise((r) => setTimeout(r, ms));
}

export async function appConfigLoader(store: typeof AppStore) {
    // await sleep(5000);
    const result = await store.dispatch(fetchAppConfig());

    if (isFulfilled(result)) {
        // Accent color
        if (result.payload.appconfig?.color) {
            const accentColor = result.payload.appconfig.color;
            document.documentElement.style.setProperty('--accent-color', accentColor);

            // Must be HEX code for adding transparancy
            if (accentColor.length === 7) {
                document.documentElement.style.setProperty('--accent-dimmed-color', `${accentColor}50`);
                document.documentElement.style.setProperty('--accent-light-color', `${accentColor}15`);
                document.documentElement.style.setProperty('--accent-lightest-color', `${accentColor}10`);
            }
        }

        // Navigation color
        if (result.payload.appconfig?.header_color) {
            document.documentElement.style.setProperty('--nav-color', result.payload.appconfig.header_color);
        }
        if (result.payload.appconfig?.header_text_color) {
            document.documentElement.style.setProperty('--nav-text-color', result.payload.appconfig.header_text_color);
        }

        // Button colors
        if (result.payload.appconfig?.button_color) {
            const buttonColor = result.payload.appconfig.button_color;
            document.documentElement.style.setProperty('--button-color', buttonColor);
            if (buttonColor.length === 7) {
                document.documentElement.style.setProperty('--button-light-color', `${buttonColor}15`);
            }
        }
        if (result.payload.appconfig?.button_text_color) {
            document.documentElement.style.setProperty(
                '--button-text-color',
                result.payload.appconfig.button_text_color,
            );
        }

        // Background and primary text
        if (result.payload.appconfig?.background_color) {
            document.documentElement.style.setProperty('--background-color', result.payload.appconfig.background_color);
        }
        if (result.payload.appconfig?.foreground_color) {
            document.documentElement.style.setProperty('--foreground-color', result.payload.appconfig.foreground_color);
        }
        if (result.payload.appconfig?.background_text_color) {
            const textColor = result.payload.appconfig.background_text_color;

            document.documentElement.style.setProperty('--text-color', textColor);
            // Must be HEX code for adding transparancy
            if (textColor.length === 7) {
                document.documentElement.style.setProperty('--text-muted-color', `${textColor}50`);
            }
        }

        // Border and input color
        if (result.payload.appconfig?.border_color) {
            document.documentElement.style.setProperty('--border-color', result.payload.appconfig.border_color);
        }
        if (result.payload.appconfig?.input_border_color) {
            document.documentElement.style.setProperty(
                '--border-dark-color',
                result.payload.appconfig.input_border_color,
            );
        }

        // Favicons
        if (result.payload.appconfig?.appicon != null) {
            ['icon', 'apple-touch-icon', 'mask-icon'].map((icon: string) => {
                const link: HTMLLinkElement | null = document.querySelector(`link[rel~='${icon}']`);
                if (link) {
                    link.href = result.payload.appconfig?.appicon ?? '';
                }
            });
        }
    }

    return result;
}
